import moment from 'moment';

export default class Quartiles {
  constructor(patientSettings = []) {
    this.patientSettings = patientSettings; 
  }

  getPatientSetting(path) {
    const setting = this.patientSettings
      .find((item) => item.path === path) || {};

    return setting.value || null;
  }

  getMorningStartTime() {
    return this.getPatientSetting("GENERAL:QUARTILES:MORNING:STARTTIMEMORNING");
  }

  getMorningEndTime() {
    return this.getPatientSetting("GENERAL:QUARTILES:MORNING:ENDTIMEMORNING");
  }

  getNoonStartTime() {
    return this.getPatientSetting("GENERAL:QUARTILES:NOON:STARTTIMENOON");
  }

  getNoonEndTime() {
    return this.getPatientSetting("GENERAL:QUARTILES:NOON:ENDTIMENOON");
  }

  getAfterNoonStartTime() {
    return this.getPatientSetting("GENERAL:QUARTILES:AFTERNOON:STARTTIMEAFTERNOON");
  }

  getAfterNoonEndTime() {
    return this.getPatientSetting("GENERAL:QUARTILES:AFTERNOON:ENDTIMEAFTERNOON");
  }

  getEveningStartTime() {
    return this.getPatientSetting("GENERAL:QUARTILES:EVENING:STARTTIMEEVENING");
  }

  getEveningEndTime() {
    return this.getPatientSetting("GENERAL:QUARTILES:EVENING:ENDTIMEEVENING");
  }

  get(time) {
    if (time instanceof moment) {
      time = time.format('HH:mm');
    }

    if (time >= this.getMorningStartTime() && time < this.getMorningEndTime()) {
      return 'MORNING';
    }

    if (time >= this.getNoonStartTime() && time < this.getNoonEndTime()) {
      return 'NOON';
    }

    if (time >= this.getAfterNoonStartTime() && time < this.getAfterNoonEndTime()) {

      return 'AFTERNOON';
    }

    return 'EVENING';
  }
}

